const commonQAModule =
    commonQAModule ||
    (() => {
        const status = {
            isInitialized: false,
        }

        const classNamePrefix = "common-qa-block"

        const questionHeadingClickHandler = (e) => {
            const target = e.target

            if (target.classList.contains("common-qa-block__question") || target.closest(".common-qa-block__question")) {
                const button = target.closest(".common-qa-block__question")
                const parentEl = button.closest(`.${classNamePrefix}__q-n-a`)
                const answer = parentEl.querySelector(`.${classNamePrefix}__answer`)

                const isExpanded = button.getAttribute("aria-expanded") === "true"

                if (isExpanded) {
                    parentEl.classList.remove("expanded")
                } else {
                    parentEl.classList.add("expanded")
                }

                // Toggle aria-expanded and hidden attributes
                button.setAttribute("aria-expanded", !isExpanded)
                answer.hidden = isExpanded
            }
        }

        function initArrows() {
            const commonQaTabs = document.querySelectorAll(".common-qa-block__tabs-outer")

            if (commonQaTabs) {
                commonQaTabs.forEach((tabBlock) => {
                    if (tabBlock) {
                        const tabInner = tabBlock.querySelector(".common-qa-block__tabs-inner")
                        const arrowContainer = tabBlock.querySelector(".common-qa-block__arrows")
                        const tabs = tabBlock.querySelectorAll(".common-qa-block__tab")

                        function checkTabsOverlap() {
                            const sum = [...tabs].reduce((accum, next) => {
                                return accum + next.clientWidth
                            }, 0)

                            if (tabInner && tabInner.clientWidth < sum) {
                                return true
                            }
                        }

                        const tabsOverlap = checkTabsOverlap()

                        if (tabsOverlap) {
                            arrowContainer.classList.add("visible")
                        }

                        arrowContainer.addEventListener("click", (e) => {
                            tabs.forEach((item, index, array) => {
                                if (e.target.closest(".common-qa-block__arrow--arrow-prev")) {
                                    if (array[index - 1]) {
                                        tabInner.scrollLeft -= array[index - 1].clientWidth
                                    }
                                } else {
                                    if (array[index + 1]) {
                                        tabInner.scrollLeft += array[index + 1].clientWidth
                                    }
                                }
                            })
                        })
                    }
                })
            }
        }

        const tabItemClickHandler = (e) => {
            const target = e.target
            const id = target.dataset.categoryId
            if (!id) return

            const tabInner = e.currentTarget
            const tabs = tabInner.querySelectorAll(`.${classNamePrefix}__tab`)
            if (tabs.length > 0) {
                tabs.forEach((tab) => {
                    tab.firstElementChild.classList.remove("active")
                })
            }
            target.classList.add("active")

            const qaBlock = target.closest(`.${classNamePrefix}`)
            const qNAs = qaBlock.querySelectorAll(`.${classNamePrefix}__q-n-a`)
            if (qNAs.length > 0) {
                qNAs.forEach((item) => {
                    const data = item.dataset.categoryIds
                    const categoryIds = data.split(",")

                    if (!categoryIds.includes(id)) {
                        item.classList.add("hidden")
                    } else {
                        item.classList.remove("hidden")
                    }
                })
            }

            renderActiveTabItem()
        }

        const calculateTabBulletSnapgrid = () => {
            const tabItems = document.querySelectorAll(`.${classNamePrefix}__tab`)
            if (tabItems.length > 0) {
                tabItems.forEach((item) => {
                    const bulletWidth = item.getBoundingClientRect().width
                    item.setAttribute("data-bullet-width", bulletWidth + "px")

                    const bulletOffsetLeft = item.offsetLeft
                    item.setAttribute("data-bullet-offset-left", bulletOffsetLeft + "px")
                })
            }
        }

        const renderActiveTabItem = () => {
            const tabsInners = document.querySelectorAll(`.${classNamePrefix}__tabs-inner`)
            if (tabsInners.length > 0) {
                tabsInners.forEach((item) => {
                    const activeItem = item.querySelector(`.${classNamePrefix}__tab span.active`)

                    if (!activeItem) {
                        item.style.removeProperty("--bullet-width")
                        item.style.removeProperty("--bullet-offset-left")
                    } else {
                        const bulletWidth = activeItem.parentElement.dataset.bulletWidth

                        const bulletOffsetLeft = activeItem.parentElement.dataset.bulletOffsetLeft
                        if (activeItem.parentElement.previousElementSibling) {
                            item.style.setProperty("--bullet-offset-left", `calc(${bulletOffsetLeft} + var(--tab-item-gap))`)
                            item.style.setProperty("--bullet-width", `calc(${bulletWidth} - var(--tab-item-gap))`)
                        } else {
                            item.style.setProperty("--bullet-offset-left", `calc(${bulletOffsetLeft})`)
                            item.style.setProperty("--bullet-width", `calc(${bulletWidth})`)
                        }
                    }
                })
            }
        }

        const init = () => {
            if (status.isInitialized) return

            const qaBlockMains = document.querySelectorAll(`.${classNamePrefix}__q-n-a`)
            if (qaBlockMains.length > 0) {
                qaBlockMains.forEach((qaBlockMain) => {
                    const questionButton = qaBlockMain.querySelector(`.${classNamePrefix}__question`)
                    if (questionButton) {
                        questionButton.addEventListener("click", questionHeadingClickHandler)
                        questionButton.addEventListener("keydown", (event) => {
                            if (event.key === "Enter" || event.key === " ") {
                                event.preventDefault() // Prevent default scrolling behavior for Space key
                                questionHeadingClickHandler(event)
                            }
                        })
                    }
                })
            }

            const innerTabContainers = document.querySelectorAll(`.${classNamePrefix}__tabs-inner`)
            if (innerTabContainers.length > 0) {
                innerTabContainers.forEach((container) => {
                    container.addEventListener("click", tabItemClickHandler)
                    container.addEventListener("keydown", (event) => {
                        if (event.key === "Enter") {
                            tabItemClickHandler(event)
                        }
                    })
                })
            }

            calculateTabBulletSnapgrid()
            renderActiveTabItem()
            initArrows()

            window.addEventListener("resize", () => {
                calculateTabBulletSnapgrid()
                renderActiveTabItem()
            })

            status.isInitialized = true
        }

        return {
            init,
        }
    })()

window.addEventListener("load", commonQAModule.init)
